<template>
  <div
    class="c-assigned-canvas-management-toolbar flex flex-wrap justify-between items-start gap-4 pa-4 rounded-2 bg-base"
  >
    <div class="flex flex-wrap items-center gap-2 flex-1">
      <CSearchFilters
        :customFilterComponents="!!launchDarkly.enable_saved_canvases_filters ? customFilterComponents : undefined"
        :disabled="!!isLoadingItems"
        entity="canvas"
        :filters="metadataFilterValues"
        hide-metadata-filters
        include-draft-values
        :initial-search-value="search"
        :owner-id="pitcherInfo?.isAnyTypeOfAdmin ? null : myUser?.id"
        :placeholder="t('canvasUI.components.templates.CSavedCanvasesManagementToolbar.searchInNameOrTags')"
        @update:filters="emit('update:filter-values', $event)"
        @update:search="emit('search', $event)"
      />
    </div>
    <div class="flex gap-4">
      <CTableColumnsSettings
        v-if="!hideView"
        :table-columns-settings="tableColumnsSettings"
        :tooltip-text="t('canvasUI.components.savedCanvases.CSavedCanvasesManagementToolbar.configureColumns')"
        @move="(payload) => emit('move', payload)"
        @restore="emit('restoreColumns')"
        @select="(payload) => emit('select', payload)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, inject, type ComputedRef } from 'vue'
import { useI18n } from 'vue-i18n'

import CSearchFilters from '@lib/components/CSearchFilters/CSearchFilters.vue'
import CTableColumnsSettings, {
  type TableColumnSetting,
} from '@lib/components/CTableColumnsSettings/CTableColumnsSettings.vue'

import type { LaunchDarklyEnv } from '@lib/types/launchDarkly.types'
import type { MetadataTemplateFieldTypeEnum, User } from '@openapi'
import type { PitcherInfo } from '@lib/types/app'

defineProps<{
  search: string
  metadataFilterValues: Record<string, any>
  tableColumnsSettings: TableColumnSetting[]
  customFilterComponents: {
    type: MetadataTemplateFieldTypeEnum
    name: string
    label: string
    options?: { label: string; value: string }[]
  }[]
  isLoadingItems?: boolean
  hideView?: boolean
}>()

const emit = defineEmits<{
  search: [s: string]
  'update:filter-values': [mf: Record<string, any>]
  move: [payload: { targetItemId: TableColumnSetting['id']; itemId: string }]
  select: [payload: { id: TableColumnSetting['id']; checked: boolean }]
  restoreColumns: []
}>()

const launchDarkly = inject<ComputedRef<LaunchDarklyEnv>>(
  'launchDarkly',
  computed(() => ({})),
)
const myUser = inject<ComputedRef<User | null>>('myUser')
const pitcherInfo = inject<ComputedRef<PitcherInfo>>(
  'pitcherInfo',
  computed(() => ({
    accessToken: '',
    instanceId: '',
    apiOrigin: '',
    isAnyTypeOfAdmin: false,
  })),
)

const { t } = useI18n()
</script>
